const rules = {
  required: v => !!v || "Required",
  phone: v =>
    /^\d{3}[-.]?\d{3}[-.]?\d{4}$/.test(v) ||
    v == null ||
    "Invalid phone number (XXX-XXX-XXXX)",
  email: v =>
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/.test(
      v
    ) || "Invalid Email"
};

export default rules;
